export const Constants = {
  OFFER_FILTER_ADDRESS: 'offer_filter_address',
}
